import { useQuery } from "react-query";
import { patronTypesApi, type PatronType } from "@/lib/api/patron-types";

export const PATRON_TYPES_QUERY_KEY = ["patron-types"] as const;

export function usePatronTypes(includeInactive = true, options?: { enabled?: boolean }) {
  return useQuery<PatronType[]>(
    [...PATRON_TYPES_QUERY_KEY, includeInactive],
    () => patronTypesApi.getAll(includeInactive),
    { staleTime: 60 * 60 * 1000, enabled: options?.enabled ?? true }
  );
}
